import { render, staticRenderFns } from "./AssetManager.vue?vue&type=template&id=467f7fe2&scoped=true"
import script from "./AssetManager.vue?vue&type=script&lang=js"
export * from "./AssetManager.vue?vue&type=script&lang=js"
import style0 from "./AssetManager.vue?vue&type=style&index=0&id=467f7fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f7fe2",
  null
  
)

export default component.exports